/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./assistantChat.vue?vue&type=template&id=1b77ebcd&scoped=true"
import script from "./assistantChat.vue?vue&type=script&lang=js"
export * from "./assistantChat.vue?vue&type=script&lang=js"
import style0 from "./assistantChat.vue?vue&type=style&index=0&id=1b77ebcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b77ebcd",
  null
  
)

export default component.exports